import React, { createContext, useEffect, useState } from "react";

import { useAuth } from "../hooks/useAuth";
import { User } from "features/user/types/User";

type AuthContextType = {
  isLoading : boolean;
  user: User;
  setUser : (user : User) => void;
};

export const AuthContext = createContext<AuthContextType>({
  isLoading : false,
  user: {
    _id: "",
    email: "",
    firstname: "",
    lastname: "",
    permissions: [],
    role: null,
    enterprise: null,
  },
  setUser : () => {},
});

const init_user = {
  _id: "",
  email: "",
  firstname: "",
  lastname: "",
  permissions: [],
  role: null,
  enterprise: null,
}

const AuthProvider = ({ children }) => {
  const { auth } = useAuth();
  const [user, setUser] = useState<User>(init_user);

  useEffect(() => {
    setUser(auth.data as User);
  }, [auth]);

  const value: AuthContextType = {
    isLoading : auth.isPending,
    user: user,
    setUser : setUser
  };

  // console.log("auth context", value);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default React.memo(AuthProvider);